import { render } from "./Structures.vue?vue&type=template&id=5d863f66&scoped=true"
import script from "./Structures.vue?vue&type=script&lang=js"
export * from "./Structures.vue?vue&type=script&lang=js"

import "./Structures.vue?vue&type=style&index=0&id=5d863f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d863f66"]])

export default __exports__